import { render, staticRenderFns } from "./customBoxNftBlind.vue?vue&type=template&id=49d88404&scoped=true&"
import script from "./customBoxNftBlind.vue?vue&type=script&lang=js&"
export * from "./customBoxNftBlind.vue?vue&type=script&lang=js&"
import style0 from "./customBoxNftBlind.vue?vue&type=style&index=0&id=49d88404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d88404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d88404')) {
      api.createRecord('49d88404', component.options)
    } else {
      api.reload('49d88404', component.options)
    }
    module.hot.accept("./customBoxNftBlind.vue?vue&type=template&id=49d88404&scoped=true&", function () {
      api.rerender('49d88404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBoxNftBlind.vue"
export default component.exports